import { assign, cloneDeep, get } from 'lodash';

const indexDefaultOptions = {
  enableSideBar: false,
  enablePrimaryNavs: true,
  enableSearch: false,
  guides: [],
  primaryNavs: [],
  spaceSwitch: {
    enable: false,
  },
  avatarDropDown: {
    enable: true,
    enableDefaultSettings: false,
    customSettings: [],
  },
};

type ObjectKey = { [key: string]: any };
// 空间首页导航配置
function spacePageOptions(options: ObjectKey) {
  return assign(cloneDeep(indexDefaultOptions), options);
}

interface LoginStatusOptions {
  afterLogin: ObjectKey;
  beforeLogin: ObjectKey;
}

export const microAppEnvEval = function(cbInMicro: (api: any) => void, cb?: () => void) {
  if (window.__MICRO_APP_ENVIRONMENT__) {
    const { globalAPI } = window?.microApp?.getData();
    cbInMicro?.(globalAPI);
  } else {
    cb?.();
  }
};

/**
 * 初始化基座的顶部导航条
 */
export const microAppNavigation = function(type: keyof LoginStatusOptions) {
  microAppEnvEval(globalAPI => {
    const loginStatusMap: LoginStatusOptions = {
      afterLogin: {},
      beforeLogin: {
        guides: [],
        avatarDropDown: {
          enable: false,
        },
      },
    };
    const wikiUrl = get(window, 'AppConfig.microApp.wiki');
    if (wikiUrl) {
      loginStatusMap.beforeLogin.guides.push({
        id: 'wiki',
        icon: 'doubt-filled',
        tooltipContent: '帮助文档',
        onClick() {
          window.open(wikiUrl);
        },
      });
    }
    const options = spacePageOptions(loginStatusMap[type]);
    globalAPI.navigation.setTopNavigation(options);
  });
};
